export default __webpack_public_path__ + "static/media/warning.c7ce1d4b.jpeg";